import { useSnackbarStore } from '@/stores/snackbarStore';

/**
 * Custom hook for accessing snackbar functionality.
 * Returns the complete snackbar API from the snackbar store.
 */
export function useSnackbar() {
  const open = useSnackbarStore((state) => state.open);
  const message = useSnackbarStore((state) => state.message);
  const severity = useSnackbarStore((state) => state.severity);
  const autoHideDuration = useSnackbarStore((state) => state.autoHideDuration);
  const title = useSnackbarStore((state) => state.title);
  const supportInfo = useSnackbarStore((state) => state.supportInfo);
  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);
  const hideSnackbar = useSnackbarStore((state) => state.hideSnackbar);

  return {
    open,
    message,
    severity,
    autoHideDuration,
    title,
    supportInfo,
    showSnackbar,
    hideSnackbar,
  };
}
